module.exports = __webpack_public_path__ + "static/Future-Leaders-full-dbe3bcde03c3d8f0e76d888a7967c5e6.png";